export default __webpack_public_path__ + "static/media/portfolio.a252fec1.svg";